export enum ApiTranslationsAttributes {
  consents = 'consents',
  member_properties = 'member_properties',
  mobile_app = 'mobile_app'
}

export interface ApiTranslations {
  consents: Record<string, string>;
  member_properties: Record<string, string>;
  mobile_app: Record<string, string>;
}
